import * as React from 'react';
import { Constants } from '@dndbeyond/character-rules-engine/es';
// TODO(components): this was a "dumb" component but it needs this type from the rules engine... so it is not dumb anymore?
const {FEET_IN_MILES} = Constants;

interface Props {
    number: number | null;
    size?: 'large';
    numberFallback: React.ReactNode;
    isDarkMode?: boolean;
}

export default class DistanceNumber extends React.PureComponent<Props, {}> {
    static defaultProps = {
        numberFallback: '--',
    };

    render() {
        const { number, size, numberFallback, isDarkMode } = this.props;

        let classNames: Array<string> = ['ddbc-distance-number'];
        if (size) {
            classNames.push(`ddbc-distance-number--${size}`);
        }

        let displayNumber: number | null = number;
        let label = 'ft.';
        if (displayNumber && displayNumber % FEET_IN_MILES === 0) {
            displayNumber = displayNumber / FEET_IN_MILES;
            label = `mile${Math.abs(displayNumber) === 1 ? '' : 's'}`;
            classNames.push('ddbc-distance-number--miles');
        }

        return (
            <span className={classNames.join(' ')}>
                <span
                    className={`ddbc-distance-number__number ${
                        isDarkMode ? 'ddbc-distance-number__number--dark-mode' : ''
                    }`}
                >
                    {displayNumber === null ? numberFallback : displayNumber}
                </span>
                <span
                    className={`ddbc-distance-number__label ${
                        isDarkMode ? 'ddbc-distance-number__label--dark-mode' : ''
                    }`}
                >
                    {label}
                </span>
            </span>
        );
    }
}
